module.exports = __webpack_public_path__ + "static/media/icon-02.6344fe56.svg";